class ProductForm extends HTMLElement {

  constructor() {
    super();
    this.form = this.querySelector('[data-product-form]');
    this.handle = this.form.dataset.productHandle
    this.form.addEventListener('submit', e => e.preventDefault());
    this.submit = this.querySelector('button[type="submit"]');
    console.log('this.submit',this.submit);
    this.initForm();
  }

  initForm() {

    const productForm = this;

    function onFormSubmit(event) {
      const eventData = event.dataset;
      const { quantity, properties } = eventData;
      let variantId = eventData.variant.id;
      const data = {
        items: [
          {
            'id': variantId,
            'quantity': quantity,
            'properties': {
              _bundle_parent: true
            }
          }
        ]
      };
      cartJs.addItems(data, '/checkout');
    }

    function onOptionChange(event) {
      const variant = event.dataset.variant;

      console.info('variant',variant);

      if (variant === null) {
        productForm.submit.innerText = 'Unavailable';
        productForm.submit.disabled = true;
      } else if (variant && !variant.available) {
        productForm.submit.innerText = 'Sold Out';
        productForm.submit.disabled = true;
      } else if (variant && variant.available) {
        productForm.submit.innerText = 'Buy Now';
        productForm.submit.disabled = false;
      }
    }

    fetch(`/products/${this.handle}.js`)
      .then(response => {
        return response.json();
      })
      .then(productJSON => {
        const productForm = new Shopify.theme.productForm.ProductForm(this.form, productJSON, {
          onOptionChange,
          onFormSubmit
        });
      });

    
  }

}
customElements.define('product-form', ProductForm);